import { useState } from 'react';
import type { FaqItem } from '@/types/content';

interface FaqAccordionProps {
  items: FaqItem[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openId, setOpenId] = useState<string | null>(items[0]?.id ?? null);

  return (
    <div className="divide-y divide-background-200/80 border-y border-background-200/80">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div key={item.id}>
            <button
              type="button"
              aria-expanded={isOpen}
              onClick={() => setOpenId(isOpen ? null : item.id)}
              className="w-full flex items-start justify-between gap-4 text-left py-5 group"
            >
              <span
                className={`font-heading font-semibold text-base md:text-lg transition-colors ${
                  isOpen ? 'text-primary-700' : 'text-foreground-900 group-hover:text-primary-700'
                }`}
              >
                {item.question}
              </span>
              <span
                className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full border transition-all ${
                  isOpen
                    ? 'bg-primary-500 border-primary-500 text-background-50 rotate-180'
                    : 'border-background-300 text-foreground-600'
                }`}
              >
                <i className="ri-arrow-down-s-line"></i>
              </span>
            </button>
            <div
              className={`grid transition-all duration-300 ${
                isOpen ? 'grid-rows-[1fr] opacity-100 pb-6' : 'grid-rows-[0fr] opacity-0'
              }`}
            >
              <p className="overflow-hidden text-sm md:text-base leading-relaxed text-foreground-600">
                {item.answer}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
}